import React from "react";
import {
  DashboardTable,
  ProgressCell,
  PaginationStyle,
  ActionCell,
} from "./DashboardTable.styles";
import NavigateButton from "../NavigateButton/NavigateButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import DeleteButton from "../DeleteButton/DeleteButton";
import SharepointButton from "../SharepointButton/SharepointButton";
import ViewValidationsButton from "../ViewValidationsButton/ViewValidationsButton";

const columns = [
  { id: "tender_id", label: "Quote ID", sortable: true },
  { id: "employer_name", label: "Employer", sortable: true },
  { id: "broker_name", label: "Broker", sortable: true },
  { id: "comments", label: "Note", sortable: true },
  { id: "tender_progress", label: "Tender Progress", align: "center", sortable: true },
  { id: "tender_status", label: "Tender Status", align: "center", sortable: false },
  { id: "author_name", label: "Author", align: "center", sortable: false },
  { id: "recent_activity", label: "Recent Activity", align: "center", sortable: true },
];

const DashboardTableComponent = ({
  tenders,
  page,
  onPageChange,
  totalPages,
  onSort,
  sortOrder,
  sortColumn,
  paginationActive = true,
  sortingActive = true,
  maxRows = 10,
  onDelete,
}) => {
  return (
    <DashboardTable>
      <TableContainer component={Paper} data-testid="tender-list">
        <Table>
          <TableHead>
            <TableRow data-testid="dashboard-element-1">
              {columns.map((col) => (
                <TableCell key={col.id} align={col.align || "left"}>
                  {sortingActive && col.sortable ? (
                    <TableSortLabel
                      active={sortColumn === col.id}
                      direction={sortColumn === col.id ? sortOrder : "asc"}
                      onClick={() => onSort(col.id)}
                      data-testid="sort-button"
                    >
                      {col.label}
                    </TableSortLabel>
                  ) : (
                    col.label
                  )}
                </TableCell>
              ))}
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tenders.map((row, index) => (
              index < maxRows && (
                <TableRow key={index} data-testid="dashboard-element-row">
                  {columns.map((col) => (
                    <TableCell key={col.id} align={col.align || "left"}>
                      {col.id === "tender_progress" ? (
                        <ProgressCell align="center" progress={row[col.id]}>
                          {row[col.id]
                            .split("_")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(" ")}
                        </ProgressCell>
                      ) : col.id === "recent_activity" ? (
                        new Date(row[col.id]).toLocaleString("en-ZA", {
                          year: "numeric",
                          month: "short",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })
                      ) : (
                        row[col.id]
                      )}
                    </TableCell>
                  ))}
                  <ActionCell>
                    {row.tender_status?.toLowerCase() !== "complete" && (
                      <NavigateButton tender={row} />
                    )}
                    <ViewValidationsButton tender={row} />
                    <DeleteButton tender={row} onDelete={onDelete} />
                    <SharepointButton tender={row} />
                  </ActionCell>
                </TableRow>
              )
            ))}
          </TableBody>
        </Table>
        {paginationActive && (
          <PaginationStyle>
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={onPageChange}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </PaginationStyle>
        )}
      </TableContainer>
    </DashboardTable>
  );
};

export default DashboardTableComponent;
